export * from "./[resetCode]";
